import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

import SweetAlert from 'react-bootstrap-sweetalert';
import { Button, Card, CardBody, CardTitle, Col, Row, Badge, FormGroup, Label, Input } from 'reactstrap';
import { Th, Thead, Tr } from 'react-super-responsive-table';

import {
  deleteDmxDevicePreset,
  activateDmxDevicePreset,
  getDmxCompatibleDevices,
  duplicateDmxDevicePresets,
} from '../../store/actions';

// AA-11839 / unificación DMX: los Focos ya no son una entidad propia -
// sus antiguas "posiciones" son ahora "presets" de un dmx_device de tipo
// SPOTLIGHT. Este listado se embebe dentro de DmxDeviceDetails.jsx.
class DmxDevicePresetList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      showConfirm: false,
      presetToDelete: null,
      popup: false,
      pop_msg: '',
      alertType: '',
      showDuplicatePicker: false,
      selectedTargetIds: [],
    };
  }

  componentDidUpdate(prevProps) {
    const { loadingDeleteDmxDevicePreset, deleteDmxDevicePresetError } = this.props;
    if (loadingDeleteDmxDevicePreset === false && prevProps.loadingDeleteDmxDevicePreset === true) {
      if (deleteDmxDevicePresetError) {
        this.setState({
          popup: true,
          pop_msg: deleteDmxDevicePresetError.message || 'Error al eliminar el preset',
          alertType: 'error',
        });
      } else {
        this.props.onRefresh();
      }
    }

    const { loadingActivateDmxDevicePreset, activateDmxDevicePresetError } = this.props;
    if (loadingActivateDmxDevicePreset === false && prevProps.loadingActivateDmxDevicePreset === true) {
      if (activateDmxDevicePresetError) {
        this.setState({
          popup: true,
          pop_msg: activateDmxDevicePresetError.message || 'Error al activar el preset',
          alertType: 'error',
        });
      } else {
        this.props.onRefresh();
      }
    }

    const { loadingDuplicateDmxDevicePresets, duplicateDmxDevicePresetsError, resultDmxDevicePresets } = this.props;
    if (loadingDuplicateDmxDevicePresets === false && prevProps.loadingDuplicateDmxDevicePresets === true) {
      this.setState({ showDuplicatePicker: false, selectedTargetIds: [] });
      if (duplicateDmxDevicePresetsError) {
        this.setState({
          popup: true,
          pop_msg: duplicateDmxDevicePresetsError.message || 'Error al duplicar los presets',
          alertType: 'error',
        });
      } else if (resultDmxDevicePresets) {
        this.setState({
          popup: true,
          pop_msg: 'Duplicación completada',
          pop_lines: this.buildDuplicateSummary(resultDmxDevicePresets.results),
          alertType: 'correct',
        });
      }
    }
  }

  buildDuplicateSummary(results) {
    return (results || []).map((r) => {
      if (r.error) return `${r.deviceName || r.targetDeviceId}: ${r.error}`;
      const parts = [];
      if (r.copied.length) parts.push(`copiados: ${r.copied.join(', ')}`);
      if (r.updated.length) parts.push(`actualizados: ${r.updated.join(', ')}`);
      return `${r.deviceName}: ${parts.join(' / ') || 'sin cambios'}`;
    });
  }

  confirmPopup() {
    this.setState({ popup: false, pop_lines: null });
  }

  confirmDelete(preset) {
    this.setState({ showConfirm: true, presetToDelete: preset });
  }

  doDelete() {
    const { user, presetToDelete } = this.state;
    this.props.deleteDmxDevicePreset({ id: presetToDelete.id, deviceId: this.props.device.id, token: user.token });
    this.setState({ showConfirm: false });
  }

  doActivate(preset) {
    const { user } = this.state;
    this.props.activateDmxDevicePreset({ id: preset.id, deviceId: this.props.device.id, token: user.token });
  }

  openDuplicatePicker() {
    const { user } = this.state;
    this.props.getDmxCompatibleDevices(user, this.props.device.id);
    this.setState({ showDuplicatePicker: true, selectedTargetIds: [] });
  }

  closeDuplicatePicker() {
    this.setState({ showDuplicatePicker: false, selectedTargetIds: [] });
  }

  toggleTarget(deviceId) {
    const { selectedTargetIds } = this.state;
    this.setState({
      selectedTargetIds: selectedTargetIds.includes(deviceId)
        ? selectedTargetIds.filter((id) => id !== deviceId)
        : [...selectedTargetIds, deviceId],
    });
  }

  doDuplicate() {
    const { user, selectedTargetIds } = this.state;
    if (selectedTargetIds.length === 0) return;
    this.props.duplicateDmxDevicePresets({
      deviceId: this.props.device.id,
      targetDeviceIds: selectedTargetIds,
      token: user.token,
    });
  }

  render() {
    const { presetList } = this.props;
    const isSpotlight = this.props.device.device_type === 'SPOTLIGHT';
    return (
      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{this.props.t('Presets')}</CardTitle>
              <Button
                color="success"
                className="btn waves-effect waves-light buttonStatus usersButtons mb-3"
                onClick={() => this.props.onCreateNew()}
              >
                {this.props.t('Crear preset')}
              </Button>
              {presetList.length > 0 ? (
                <Button
                  color="secondary"
                  className="btn waves-effect waves-light buttonStatus usersButtons mb-3 ml-2"
                  onClick={() => this.openDuplicatePicker()}
                >
                  {this.props.t('Duplicar a otros dispositivos')}
                </Button>
              ) : null}
              {this.state.showDuplicatePicker ? (
                <Card className="border">
                  <CardBody>
                    <CardTitle>{this.props.t('Duplicar todos los presets de este dispositivo a...')}</CardTitle>
                    {!this.props.compatibleDevices ? (
                      <p>{this.props.t('Cargando dispositivos...')}</p>
                    ) : this.props.compatibleDevices.length === 0 ? (
                      <p>{this.props.t('No hay otros dispositivos con el mismo perfil.')}</p>
                    ) : (
                      this.props.compatibleDevices.map((d) => (
                        <FormGroup check key={d.id}>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={this.state.selectedTargetIds.includes(d.id)}
                              onChange={() => this.toggleTarget(d.id)}
                            />{' '}
                            {d.name}
                          </Label>
                        </FormGroup>
                      ))
                    )}
                    <div className="mt-3">
                      <Button
                        color="secondary"
                        className="buttonStatus"
                        disabled={this.state.selectedTargetIds.length === 0}
                        onClick={() => this.doDuplicate()}
                      >
                        {this.props.t('Duplicar')}
                      </Button>
                      <Button color="light" className="buttonStatus ml-2" onClick={() => this.closeDuplicatePicker()}>
                        {this.props.t('Cancelar')}
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              ) : null}
              <div className="table-responsive">
                <table className="table table-centered table-nowrap mb-0">
                  <Thead>
                    <Tr>
                      <Th>{this.props.t('Nombre')}</Th>
                      {isSpotlight ? <Th>{this.props.t('Activo')}</Th> : null}
                      <Th>{this.props.t('Actions')}</Th>
                    </Tr>
                  </Thead>
                  <tbody>
                    {presetList.map((p) => (
                      <tr key={p.id}>
                        <td>
                          <span>{p.name}</span>
                        </td>
                        {isSpotlight ? (
                          <td>
                            <Badge color={p.active ? 'success' : 'secondary'} className="font-size-13" pill>
                              {p.active ? this.props.t('Sí') : this.props.t('No')}
                            </Badge>
                          </td>
                        ) : null}
                        <td>
                          <button
                            className="btn btn-primary waves-effect waves-light buttonStatus txtField"
                            title="Editar"
                            onClick={() => this.props.onEdit(p.id)}
                          >
                            <i className="mdi mdi-pencil font-size-14 align-middle"></i>
                          </button>
                          {!p.active && isSpotlight ? (
                            <button
                              className="btn btn-success waves-effect waves-light buttonStatus txtField"
                              title="Activar"
                              onClick={() => this.doActivate(p)}
                            >
                              <i className="mdi mdi-check font-size-14 align-middle"></i>
                            </button>
                          ) : null}
                          <button
                            className="btn btn-danger waves-effect waves-light buttonStatus txtField"
                            title="Eliminar"
                            onClick={() => this.confirmDelete(p)}
                          >
                            <i className="far fa-trash-alt font-size-14 align-middle"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
        {this.state.showConfirm ? (
          <SweetAlert
            showCancel
            title="¿Estás seguro?"
            cancelBtnBsStyle="danger"
            confirmBtnBsStyle="success"
            confirmBtnText={this.props.t('ok')}
            cancelBtnText={this.props.t('Cancel')}
            onConfirm={() => this.doDelete()}
            onCancel={() => this.setState({ showConfirm: false })}
          ></SweetAlert>
        ) : null}
        {this.state.popup ? (
          <SweetAlert
            type={this.state.alertType === 'correct' ? 'success' : 'error'}
            confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
            title={this.state.pop_msg}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.confirmPopup()}
          >
            {this.state.pop_lines
              ? this.state.pop_lines.map((line, i) => (
                  <div key={i} style={{ textAlign: 'left' }}>
                    {line}
                  </div>
                ))
              : null}
          </SweetAlert>
        ) : null}
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  const { loadingDeleteDmxDevicePreset, deleteDmxDevicePresetError } = state.deleteDmxDevicePreset;
  const { loadingActivateDmxDevicePreset, activateDmxDevicePresetError } = state.activateDmxDevicePreset;
  const { devices: compatibleDevices } = state.getDmxCompatibleDevices;
  const { loadingDuplicateDmxDevicePresets, duplicateDmxDevicePresetsError, resultDmxDevicePresets } = state.duplicateDmxDevicePresets;
  return {
    loadingDeleteDmxDevicePreset,
    deleteDmxDevicePresetError,
    loadingActivateDmxDevicePreset,
    activateDmxDevicePresetError,
    compatibleDevices,
    loadingDuplicateDmxDevicePresets,
    duplicateDmxDevicePresetsError,
    resultDmxDevicePresets,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    deleteDmxDevicePreset,
    activateDmxDevicePreset,
    getDmxCompatibleDevices,
    duplicateDmxDevicePresets,
  })(withNamespaces()(DmxDevicePresetList)),
);
